import { createContext } from "react";

export const MessagingContext = createContext(null);
export const ServiceWorkerContext = createContext(null);
